export default "__VITE_ASSET__CC$aRPvZ__"